<template>
  <div class="week-template">
    <div class="search-form-box">
      <el-row :gutter="30">
        <el-form inline>
          <el-col :span="5">
            <el-form-item label="日期范围:">
<!--              <custom-date-range-->
<!--                :start-date="searchForm.startTime"-->
<!--                :end-date="searchForm.endTime"-->
<!--                @update:startDate="(val) => (searchForm.startTime = val)"-->
<!--                @update:endDate="(val) => (searchForm.endTime = val)"></custom-date-range>-->
              <el-date-picker
                style="width: 100%"
                v-model="value1"
                type="week"
                format="yyyy 第 WW 周"
                value-format="yyyy-MM-dd"
                placeholder="选择周"
                :picker-options="{ firstDayOfWeek: 1 }"
                @change="handleWeekChange">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="">
              <el-button type="primary" round icon="el-icon-search" @click="handleCheck()"></el-button>
              <el-button type="default" round icon="el-icon-refresh" @click="getData()"></el-button>
              <el-button type="primary" :loading="downloadLoading" @click="handleDownload(`司机出勤率表${searchForm.startTime}-${searchForm.endTime}.xlsx`)">导出</el-button>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
    </div>
    <div class="custom-table-box">
      <custom-table
        :data="tableData"
        :column="tableColumn"
        :loading="tableOptions.loading"
        :selection="false"
        :show-pagination="false"></custom-table>
    </div>

    <!--    添加或编辑-->
    <addOrEdit ref="addOrEdit"></addOrEdit>
  </div>
</template>

<script>
import OperateBox from "@/components/OperateBox.vue";
import CustomTable from "@/components/CustomTable.vue";
import addOrEdit from "./addOrEdit.vue";
import {  downloadExcel, getPage } from "./api";
import tableMixin from "@/mixin/tableMixin";
import CustomDateRange from "@/components/CustomDateRange.vue";
import { blobToText, downloadFileCustom } from "@/utils/tool";
import dayjs from "dayjs";
import weekday from 'dayjs/plugin/weekday'
dayjs.extend(weekday)
export default {
  name: "DriverPerformanceReport",
  mixins: [tableMixin],
  components: {
    CustomDateRange,
    OperateBox,
    CustomTable,
    addOrEdit,
  },
  data() {
    return {
      value1: "",
      downloadFileMethod: downloadExcel,
      searchForm: {
        startTime: "",
        endTime: "",
      },
      tableColumn: [
        {
          label: "服务商名称",
          prop: "companyName",
          show: true,
        },
        {
          label: "完成单数",
          prop: "completeNum",
          show: true,
        },
        {
          label: "派单总数",
          prop: "dispatchNum",
          show: true,
        },
        {
          label: "司机数",
          prop: "driverNum",
          show: true,
        },
        {
          label: "出勤率",
          prop: "attendanceRate",
          show: true,
        },
        {
          label: "报表日期",
          prop: "statementDate",
          show: true,
        },
        {
          label: "开始日期",
          prop: "startTime",
          show: true,
        },
        {
          label: "结束日期",
          prop: "endTime",
          show: true,
        },
      ],
      isImmediatelyGetData: false,
    };
  },
  watch: {
    value1: function (val) {
      this.getData()
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    handleWeekChange(selectedDay) {
      if (!selectedDay) {
        this.searchForm.startTime = "";
        this.searchForm.endTime = "";
        return;
      }
      const d = dayjs(selectedDay);

      // 格式化 yyyy-MM-dd
      this.searchForm.startTime = d.weekday(1).format("YYYY-MM-DD");
      this.searchForm.endTime = d.weekday(7).format("YYYY-MM-DD");
    },
    handleDownload(fileName) {
      //没有数据的时候禁止导出操作
      if (this.tableData.length === 0) {
        this.$message.error("暂无数据导出！");
        return;
      }
      this.downloadLoading = true;
      this.downloadFileMethod(this.searchForm)
        .then((res) => {
          this.downloadLoading = false;

          blobToText(res.data).then((data) => {
            // // // console.log("data", data);
            downloadFileCustom(data, fileName);
          });
        })
        .catch(() => {
          this.downloadLoading = false;
        });
    },
    handleCheck() {
      this.value1 = "";
      this.searchForm.startTime = ""
      this.searchForm.endTime = ""
      this.getData()
    },
    getData() {
      // // console.log("this.searchForm", this.searchForm);
      this.tableOptions.loading = true
      getPage({
        startTime: this.searchForm.startTime,
        endTime: this.searchForm.endTime
      }).then(res => {
        if (res.code === 200) {
          this.tableData = res.data;
        }
      }).finally(() => {

        this.tableOptions.loading = false
      })
    }
  },
};
</script>
<style lang="scss" scoped>
.week-template {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .search-form-box {
    flex-shrink: 0;
  }
  .custom-table-box{
    padding-top: 0;
    padding-left: 0;
    flex: 1;
  }
}
</style>
